function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import FullscreenSlider from './fullscreenSlider.js';
import ProGallerySlider from './ProGallerySlider';
import { fixedStyles } from './proGallerySliderFixedStyles';
import MobileZoom from './MobileZoom';

var MobileFullscreen = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MobileFullscreen, _React$Component);

  function MobileFullscreen(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.isExpandedView = false;
    _this.isTouchDeviceZoom = true;
    return _this;
  }

  var _proto = MobileFullscreen.prototype;

  _proto.getSlider = function getSlider() {
    var shouldUseProGallerySlider = this.props.shouldUseProGallerySlider;

    var props = _objectSpread(_objectSpread({}, this.props), {}, {
      isExpandedView: this.isExpandedView,
      isTouchDeviceZoom: this.isTouchDeviceZoom
    });

    if (shouldUseProGallerySlider) {
      return this.getProGallerySlider();
    }

    return /*#__PURE__*/React.createElement(FullscreenSlider, props);
  };

  _proto.getProGallerySlider = function getProGallerySlider() {
    var _this$props = this.props,
        items = _this$props.items,
        resizeMediaUrl = _this$props.resizeMediaUrl,
        totalItems = _this$props.totalItems,
        current = _this$props.current,
        actions = _this$props.actions,
        currentWindow = _this$props.currentWindow;
    var props = {
      container: currentWindow.size,
      items: items,
      totalItemsCount: totalItems,
      resizeMediaUrl: resizeMediaUrl,
      currentIdx: current.item.idx,
      actions: actions,
      styles: fixedStyles.mobileFullscreen
    };
    var style = {
      height: '100%'
    };
    return /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement(ProGallerySlider, props));
  };

  _proto.getCloseButton = function getCloseButton() {
    var _this$props2 = this.props,
        actions = _this$props2.actions,
        itemClickIsOpenInFullscreen = _this$props2.itemClickIsOpenInFullscreen;
    var onClickFunction = itemClickIsOpenInFullscreen ? function () {
      return actions.closeBrowserFullscreen(true);
    } : function () {
      return actions.toggleFullscreen(false);
    };
    return /*#__PURE__*/React.createElement("button", {
      style: {
        zIndex: 1000
      },
      className: "fullscreen-icon fullscreen-toggle-zoom progallery-svg-font-icons-close-x ",
      onClick: onClickFunction
    });
  };

  _proto.getMobileZoom = function getMobileZoom() {
    return /*#__PURE__*/React.createElement(MobileZoom, {
      currentGalleryItem: this.props.currentGalleryItem,
      current: this.props.current,
      currentWindow: this.props.currentWindow,
      styles: this.props.styles,
      container: this.props.container,
      actions: this.props.actions
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref) {
        return _this2.props.setRef(_ref);
      },
      "data-hook": "fullscreen-view",
      id: "fullscreen-view",
      className: this.props.fullscreenClasses,
      role: "dialog",
      "aria-label": "Gallery item, detailed view",
      tabIndex: -1
    }, this.props.isMobileZoom ? this.getMobileZoom() : null, this.getSlider(), this.getCloseButton());
  };

  return MobileFullscreen;
}(React.Component);

export default MobileFullscreen;